import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

// Contenido y funciones del servicio
const funciones = [
  "Carga y descarga de hasta 10 destinos por transportista",
  "Subcontratación y liquidación automática de transportistas externos",
  "Asignación de rutas y seguimiento en tiempo real",
  "Facturación integrada para control total"
];

const ModuloGestionTransporte = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      <div className="fondo-aplicacion">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo Módulo de Gestión de Transporte"
        />
        <div className="fondo-aplicacion-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-aplicacion">Módulo de Gestión de Transporte para Sage 200</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/modulogestiontransporte1.jpg`}
          alt="Módulo de Gestión de Transporte 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Organiza rutas, controla subcontrataciones y mantiene la trazabilidad de cada entrega con nuestro módulo de gestión de transporte. 
            Automatiza y optimiza toda la operación de principio a fin, integrado con Sage 200 para una gestión eficiente.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/modulogestiontransporte${num}.jpg`}
                alt={`Módulo de Gestión de Transporte ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/modulogestiontransporte${num}.jpg`}
              alt={`Módulo de Gestión de Transporte ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>Optimiza tu Gestión de Transporte</h2>
        <p>Automatiza rutas, subcontrataciones y facturación para una operación más eficiente.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default ModuloGestionTransporte;
